// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"9ac1c22d19acf666746e","678":"4214ac6ae9c344e11561","883":"107be6e46dd042f42796"}[chunkId] + ".js";
};